module.exports = __webpack_public_path__ + "img/三会一课.f246dd7e.png";